export const followupsPath = () => "/followups";
export const followupShowPath = (followup) => `/followups/${followup.id}`;
